import React from 'react'

export default function PageFooterInvisible() {
  return (
    <>
    </>
  )
}